"use client";
import MainBanner from "@/components/main-banner.component";
import Header from "@/layouts/header";
import authorAPI from "@/services/author_api";
import PolicyFooter from "@/layouts/policy-footer";
import { Pagination, Spin } from "antd";
import React, { useEffect, useState, Suspense } from "react";
import { useRouter, useSearchParams, ReadonlyURLSearchParams } from "next/navigation";
import { ResponseTypes } from "@/types/constants";
import AuthorCard from "@/modules/author-card";
import { definitions } from "@/services/metruyenvl";

function AuthorPages() {
    const [listAuthors, setListAuthors] = useState<definitions["models.AuthorMD"][]>([]);
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const searchParams: ReadonlyURLSearchParams = useSearchParams();
    const router = useRouter();
    const [pageSize, setPageSize] = useState<number>(20);
    useEffect(() => {
        setPageSize(parseInt(searchParams.get("size") ?? "20"));
        const getAuthors = async () => {
            setLoading(true);
            try {
                const res: ResponseTypes = await authorAPI.getAll(parseInt(searchParams.get("page") ?? "1"), parseInt(searchParams.get("size") ?? "20"));
                setListAuthors(res.data);
                setTotal(res.paging?.total ?? 0);
            } catch (error) {
                console.log(error);
            }
            setLoading(false);
        };
        getAuthors();
    }, [searchParams]);
    const changePage = (e: number, size: number) => {
        // setPage(e);
        setPageSize(size);
        router.push(`/tac-gia?page=${e}&size=${size}`);
    };
    return (
        <div>
            <Header />
            <MainBanner />
            <div className="w-full xl:pr-60 xl:pl-60 md:pr-32 relative md:pl-32 2xl:pr-72 2xl:pl-72">
                <Spin spinning={loading}>
                    <div className="bg-white rounded-lg md:mt-[-100px] p-3 md:p-6">
                        <div className="md:mb-4 text-black font-semibold text-lg">Danh sách các tác giả</div>{" "}
                        <div className="grid md:grid-cols-2 grid-cols-1 gap-x-2 gap-y-4">
                            {listAuthors.map((item: definitions["models.AuthorMD"]) => {
                                return <AuthorCard key={item.id} author={item} />;
                            })}
                        </div>
                        <Pagination total={total} current={parseInt(searchParams.get("page") ?? "1")} pageSize={pageSize} onChange={changePage} className="float-right mb-4 mt-4" />
                    </div>
                </Spin>
            </div>
            <PolicyFooter />
        </div>
    );
}

function Pages() {
    return (
        <Suspense>
            <AuthorPages />
        </Suspense>
    );
}

export default Pages;
